import * as React from "react";
import "./profileTop.css";
import "../../style/App.css";

const hairColorArray = ["bright", "dark", "grey", "mid", "red"];
const genderArray = ["female", "male"];

export type AvatarData = {
  cloth: number;
  face: number;
  gender: number;
  hairStyle: number;
  hairColor: number;
  special: number;
  skin: number;
};

type Props = {
  avatar: AvatarData;
  width: number;
  height: number;
};

class Avatar extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  renderLayer(path: string) {
    return (
      <div className="AVATAR">
        <img
          width={this.props.width}
          height={this.props.height}
          src={path}
          srcSet={`${path} 1x, ${path.replace(
            ".png",
            "@2x.png"
          )} 2x,  ${path.replace(".png", "@3x.png")} 3x`}
        />
      </div>
    );
  }
  render() {
    const gender = this.props.avatar?.gender ?? 0;
    const skin = this.props.avatar?.skin ?? 0;
    const hairStyle = this.props.avatar?.hairStyle ?? 0;
    const hairColor = this.props.avatar?.hairColor ?? 0;
    const cloth = this.props.avatar?.cloth ?? 0;
    const face = this.props.avatar?.face ?? 0;
    const special = this.props.avatar?.special ?? 0;
    return (
      <div>
        <div className="AVATAR_CONTAINER">
          {this.renderLayer(
            "https://static.smokeless.world/avatar/v3/avatar_layer_1_background.png"
          )}

          {this.renderLayer(
            "https://static.smokeless.world/avatar/v3/avatar_layer_2_hair_back_" +
              genderArray[gender] +
              "_" +
              hairColorArray[hairColor] +
              "_" +
              hairStyle +
              ".png"
          )}
          {this.renderLayer(
            "https://static.smokeless.world/avatar/v3/avatar_layer_3_skin_" +
              skin +
              ".png"
          )}
          {this.renderLayer(
            "https://static.smokeless.world/avatar/v3/avatar_layer_4_cloth_" +
              cloth +
              ".png"
          )}
          {this.renderLayer(
            "https://static.smokeless.world/avatar/v3/avatar_layer_5_face_" +
              genderArray[gender] +
              "_" +
              hairColorArray[hairColor] +
              "_" +
              face +
              ".png"
          )}
          {this.renderLayer(
            "https://static.smokeless.world/avatar/v3/avatar_layer_6_hair_front_" +
              genderArray[gender] +
              "_" +
              hairColorArray[hairColor] +
              "_" +
              hairStyle +
              ".png"
          )}

          {this.renderLayer(
            "https://static.smokeless.world/avatar/v3/avatar_layer_7_special_" +
              special +
              ".png"
          )}
        </div>
      </div>
    );
  }
}

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/profileTop/avatar.tsx